module.exports = "<div id=category-filter class=aside__filters> <div class=\"widget__products widget-aside\"> <h6 class=\"widget__title bg-base text-uppercase bg-gradient\">Líneas de Productos</h6> <div class=\"widget__wrapper widget__accordion\"> <categories-accordion items=$ctrl.shCtrl.globalCategoriesMenu[0].hijas></categories-accordion> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/categories-slider-filter/templates/categories-slider-filter-base.view.html
 ** module id = 642
 ** module chunks = 7
 **/